/* ProductScreen reviews */
export const REVIEWS_PER_PAGE = 9;

export const RATING_OPTS = [
  { value: '', children: 'Select...' },
  { value: '1', children: '1- Poor' },
  { value: '2', children: '2- Fair' },
  { value: '3', children: '3- Good' },
  { value: '4', children: '4- Very good' },
  { value: '5', children: '5- Exzellent' }
];
